import { z } from 'zod';

const envSchemaPublic = z.object({
  GATSBY_PUBLIC_URL_INSTITUCIONAL: z.string().url(),
  GATSBY_PUBLIC_URL_PACIENTE: z.string().url(),
  GATSBY_PUBLIC_API_BASE_URL: z.string().url(),
  GATSBY_PUBLIC_SENTRY_ENVIRONMENT: z.enum([
    'development',
    'preview',
    'staging',
    'production',
  ]),
  GATSBY_PUBLIC_API_TIMEOUT: z.coerce.number().int().positive(),
  GATSBY_PUBLIC_INACTIVITY_LIMIT: z.coerce.number().int().positive(),
});

const parsedEnv = envSchemaPublic.safeParse({
  GATSBY_PUBLIC_URL_INSTITUCIONAL: process.env.GATSBY_PUBLIC_URL_INSTITUCIONAL,
  GATSBY_PUBLIC_URL_PACIENTE: process.env.GATSBY_PUBLIC_URL_PACIENTE,
  GATSBY_PUBLIC_API_BASE_URL: process.env.GATSBY_PUBLIC_API_BASE_URL,
  GATSBY_PUBLIC_SENTRY_ENVIRONMENT: process.env.GATSBY_PUBLIC_SENTRY_ENVIRONMENT,
  GATSBY_PUBLIC_API_TIMEOUT: process.env.GATSBY_PUBLIC_API_TIMEOUT,
  GATSBY_PUBLIC_INACTIVITY_LIMIT: process.env.GATSBY_PUBLIC_INACTIVITY_LIMIT,
});

if (!parsedEnv.success) {
  console.error('Some environment client variable is incorrect.', parsedEnv.error.errors);
  throw new Error('Invalid environment variables.');
}

export const env = parsedEnv.data;
